var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-col',{staticClass:"mx-4"},[_c('div',[_c('h1',{staticClass:"text-center"},[_vm._v(" You don't have permission to access to resource ")])])])}
var staticRenderFns = []

export { render, staticRenderFns }